import { Component, OnInit, Inject, Input } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import {Observable} from "rxjs";
import { Reminder } from '../../models/reminder';
import { ReminderService } from '../../services/reminder.service';
import * as esLocale from "date-fns";

@Component({
  selector: 'app-reminder-dialog',
  templateUrl: './reminder-dialog.component.html',
  styleUrls: ['./reminder-dialog.component.css']
})
export class ReminderDialogComponent implements OnInit {
  @Input() editReminder: any;
  msgLoading: boolean;
  reminder: any;
  errorMessage: string;
  publicating: boolean;
  es: any;
  date: Date;
  time: Date;

  constructor(
    @Inject(MD_DIALOG_DATA) public data: any,
    public reminderService: ReminderService,
    public dialogRef: MdDialogRef<ReminderDialogComponent>,
  ) { }

  ngOnInit() {
    this.es = {
    firstDayOfWeek: 1,
      dayNames:["domingo","lunes","martes","miércoles","jueves","viernes","sábado" ],
      dayNamesShort: [ "dom","lun","mar","mié","jue","vie","sáb" ],
      monthNames: [ "enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre" ],
      monthNamesShort: [ "ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic" ],
      dateFns: esLocale
    };

    this.publicating = false;
    this.reminder = {
      id: this.editReminder.id,
      dateandtime: this.editReminder.start,
      details: this.editReminder.title,
      user: this.editReminder.user
    };
    this.date = new Date (this.reminder.dateandtime);
    this.time = new Date (this.reminder.dateandtime);
  }

  onPutReminder () {
    this.publicating = true;
    const month = this.date.getMonth() + 1;
    const a = this.date.getFullYear() + '-' + month + '-' + this.date.getDate() + ' ' + this.time.getHours() +
    ':' + this.time.getMinutes() + ':00:00';
    this.reminder.dateandtime = new Date (a);
    this.reminderService.putReminder(this.reminder)
    .subscribe(
      data => {
        this.dialogRef.close();
        this.publicating = false;
      },
      error => {
        this.errorMessage = <any>error
        this.publicating = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/reminder-dialog/reminder-dialog.component.ts